import React, { createContext, useState } from "react";

const TemplateContextModule = createContext();

const TemplateModuleProvider = ({ children }) => {
  const [fetchByTemplateId, setFetchByTemplateId] = useState();
  const [customTemplateSize, setCustomTemplateSize] = useState(0);
  const [templateIBNOCeanJSON, setTemplateIBNOCeanJSON] = useState();

  return (
    <TemplateContextModule.Provider
      value={{
        fetchByTemplateId,
        setFetchByTemplateId,
        customTemplateSize,
        setCustomTemplateSize,
        templateIBNOCeanJSON,
        setTemplateIBNOCeanJSON,
      }}
    >
      {children}
    </TemplateContextModule.Provider>
  );
};

export { TemplateContextModule, TemplateModuleProvider };
